<template>
  <Card class="w-full" :style="'height:' + height">
    <CardHeader>
      <CardTitle class="text-subtitle border-b">Recent Uploads</CardTitle>
      <CardDescription>
        You've had {{ totalMedia }} uploads in the last 30 days.
      </CardDescription>
    </CardHeader>
    <CardContent class="overflow-y-auto bg-background relative">
      <MediaList v-model="selectedMedia" v-if="vhostId !== null" :filters="filters" type="list" :vhostId="vhostId" sort-order="upload desc" default-profile="11" @set-total-count="setTotalMedia" />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { ref, reactive, inject,Ref } from 'vue';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import MediaList from '@/components/MediaList.vue';
import type { Filters } from '@/types/Filters';
import type { Media } from '@/types/Media';

const props = defineProps({
  height: {
    type: String,
    required: false,
    default: "400px"
  }
});

const vhostId = inject<Ref<string>>('vhostId', ref("0"));
const totalMedia = ref(0);
const selectedMedia = ref<Media[]>([]);
const filters = reactive<Filters>({ 
  filetype: [1, 2], 
  startTime: '30 days ago' 
});

const setTotalMedia = (count: any): number => {
  return totalMedia.value = parseInt(count);
};
</script>
